import React from 'react';
import { SectionList } from '@/features/constructorCommon';
import { useQuestionnaireSections } from '@/features/constructor/hooks';

export const QuestionnaireSectionList = ({questionnaireId = '', ...props}) => {
  const {data, isLoading} = useQuestionnaireSections(questionnaireId);

  return (
    <SectionList data={data} isLoading={isLoading} type={'questionnaire'} {...props}/>
  );
};
